/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationCountriesQueryResponse,
  GetApiV1LocationCountries401,
  GetApiV1LocationCountries500,
} from "../../types/locationCountryController/GetApiV1LocationCountries.ts";

function getGetApiV1LocationCountriesUrl() {
  const res = { method: "GET", url: `/api/v1/location/countries` as const };
  return res;
}

/**
 * @description Retorna todos os países cadastrados, com o nome resolvido pelo idioma corrente, ordenados alfabeticamente. **(Requer Authorization para autenticação)**
 * @summary Listar países (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries}
 */
export async function getApiV1LocationCountries(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationCountriesQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationCountries401 | GetApiV1LocationCountries500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationCountriesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
